import * as Sentry from '@sentry/browser';

const eventTrack = (eventName, eventPayload, method = 'rp') => {
  try {
    const { window } = global;

    if (window.SS && window.SS.Require) {
      window.SS.Require(() => {
        window.SS.EventTrack[method](eventName, eventPayload);
      });
    }
  } catch (error) {
    Sentry.captureException(error);
  }
};

export default eventTrack;

// fires an asynchronous ET beacon to SiteSpect
// can be used most of the time
export const rp = eventTrack;

// fires a synchronous ET beacon to SiteSpect
// should be used when related to an event that causes a page load/navigation
export const rpSync = (eventName, eventPayload) => eventTrack(eventName, eventPayload, 'rpSync');
